import React from "react";
import Product from "../components/Product";
import Slider from "../components/Slider";

const Home = () => {
  return (
    <div>
      <Slider />
      <Product />
    </div>
  );
};

export default Home;
